export const userActions = {
  userCreateError: "Sorry, there was an error creating the user",
  userUpdateError: "Sorry, there was an error updating the user",
  emailTaken: "Sorry, this user email has already been taken",
  requestCancelled: "There was a problem or request was cancelled"
};
